module.exports = __webpack_public_path__ + "static/media/icon-filter-inactive.906b5efd.svg";